import { useEffect, useCallback, MutableRefObject, useContext, MouseEvent } from 'react';
import noop from 'lodash/noop';
import RootContext from 'ia-react-core/~/components/config/_RootContext';
import { CustomContentProps } from '../DropList';

interface UseDropListClickOutside {
  targetRef: MutableRefObject<HTMLElement>;
  popperRef: MutableRefObject<HTMLDivElement>;
  isOpened: boolean;
  setIsOpened: (isOpened: boolean) => void;
  keepOpen: CustomContentProps['keepOpen'];
}

const useDropListClickOutside = ({ targetRef, popperRef, isOpened, setIsOpened, keepOpen }: UseDropListClickOutside) => {
  const { root } = useContext(RootContext);

  const handleDocumentClick = useCallback((event: Event) => {
    const shouldCloseDropList = (
      targetRef.current !== event.target &&
      !targetRef.current.contains(event.target as Node) &&
      popperRef.current !== event.target &&
      !popperRef.current.contains(event.target as Node)
    );

    if (shouldCloseDropList && (event as unknown as { keepDropListOpened: boolean }).keepDropListOpened !== true) {
      setIsOpened(false);
    } else {
      keepOpen({ nativeEvent: event } as MouseEvent<any>);
    }
  }, [keepOpen, popperRef, setIsOpened, targetRef]);

  useEffect(() => {
    if (isOpened) {
      root.addEventListener('mousedown', handleDocumentClick);

      return () => {
        root.removeEventListener('mousedown', handleDocumentClick);
      };
    }

    return noop;
  }, [handleDocumentClick, isOpened, root]);
};

export default useDropListClickOutside;
